import { useCallback, useMemo } from 'react'
import axios from 'axios'
import { useMutation } from '@tanstack/react-query'

import config from '../../config'

import { IGetPostRequest, IUseAddMutation, IAddFn, ISafetyCaseHazard, ISafetyCaseHazardAddUpsert } from '../../interfaces'

const getCreateSafetyCaseHazardMutationRequest: IGetPostRequest = () => ({
  method: 'post',
  url: `${config.baseUrl}/sms/Hazards`,
})

const useCreateSafetyCaseHazardMutation: IUseAddMutation<ISafetyCaseHazard, ISafetyCaseHazardAddUpsert> = (
  params,
  options = {},
) => {
  const request = useMemo(() => getCreateSafetyCaseHazardMutationRequest(params), [params])

  const createSafetyCaseHazard: IAddFn<ISafetyCaseHazardAddUpsert, ISafetyCaseHazard> = useCallback(
    async data => axios({ ...request, data }).then(res => res.data),
    [request],
  )

  const response = useMutation<ISafetyCaseHazard, Error, ISafetyCaseHazardAddUpsert>({
    mutationFn: createSafetyCaseHazard,
    ...options,
  })

  return response
}

export default useCreateSafetyCaseHazardMutation
